<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { modalRef, closeButtonRef, isOpen, close, handleKeydown } = useLoginModal()
const { t } = useI18n()

const keys = useMagicKeys()
const escape = computed(() => keys.escape?.value ?? false)

watch(escape, () => {
  if (isOpen.value) close()
})
</script>

<template>
  <Teleport to="body">
    <div
      v-if="isOpen"
      ref="modalRef"
      class="modal modal-login"
      role="dialog"
      aria-modal="true"
      aria-labelledby="login-modal-title"
      @keydown="handleKeydown"
    >
      <div class="background" @click="close" />
      <div class="content">
        <button ref="closeButtonRef" class="close" type="button" @click="close">
          <Icon name="large-close" />
        </button>
        <h2 id="login-modal-title" class="sr-only">{{ t('login title') }}</h2>
        <ShopLoginForm @close="close" @success="close" />
      </div>
    </div>
  </Teleport>
</template>

<style lang="scss" scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  overflow-y: auto;

  display: flex;
  flex-direction: column;
  align-items: center;

  box-shadow: var(--shadow);

  z-index: 101;
}

.background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.content {
  position: relative;
  width: min(600px, 100%);

  margin-block: 100px;
  background-color: var(--c-white);

  @include fluid(padding, 32px, 50px);
}

.close {
  position: absolute;
  top: 0;
  right: 0;
  padding: 16px;
  background-color: transparent;
  border: none;
  cursor: pointer;
}
</style>
